import {
  Box,
  CircularProgress,
  Grid,
  Link,
  makeStyles,
  Typography
} from '@material-ui/core';
import ContentContainer from '../ContentContainer';
import { useApi } from './DynamicForms/fetchHook';
import { LoadingState, SearchResultsResponse } from '../types';
import { buildQueryString } from '../requests';
import { Alert } from '@material-ui/lab';
import { Favorite } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  },
  gray: {
    color: '#3a3a3a'
  },
  link: {
    '&:hover': {
      textDecoration: 'none'
    }
  },
  mainButton: {
    width: '100%',
    marginTop: 10,
    [theme.breakpoints.up('sm')]: {
      width: 250
    }
  },
  buttonContainer: {
    maxWidth: 1440,
    margin: '0 auto',
    paddingLeft: 24,
    paddingRight: 24
  },
  disabled: {
    cursor: 'not-allowed'
  }
}));

const FavoriteContainer: React.FC = () => {
  const classes = useStyles();
  const [formList, isLoading, error] = useApi<SearchResultsResponse>(
    buildQueryString({ favoritesOnly: true })
  );

  return (
    <ContentContainer>
      <Box marginBottom={2}>
        <Typography variant="h5" className={classes.gray}>
          Suosikit
        </Typography>
      </Box>
      {isLoading === LoadingState.IsLoading && (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={24} />
        </Box>
      )}
      {error && <Alert severity="error">Virhe ladattaessa suosikkeja</Alert>}
      {isLoading !== LoadingState.IsLoading && !error && formList && (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          style={{ backgroundColor: '#FFFFFF' }}
        >
          {formList.results.length === 0 ? (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography color="textSecondary">
                Et ole lisännyt yhtään suosikkia. Voit lisätä lomakkeen
                suosikiksi painamalla <Favorite style={{ marginBottom: -6 }} />
                -ikonia lomakelistassa.
              </Typography>
            </Grid>
          ) : (
            formList?.results.map((form) => {
              return (
                <Grid style={{ marginBottom: 16 }} key={form.formId}>
                  <Link component={RouterLink} to={`/lomake/${form.formId}`}>
                    <Box>
                      <Typography color="primary">{`${form.formId} | ${form.formName}`}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" color="textPrimary">
                        {form.description}
                      </Typography>
                    </Box>
                  </Link>
                </Grid>
              );
            })
          )}
        </Grid>
      )}
    </ContentContainer>
  );
};

export default FavoriteContainer;
